import enMessages from './en';
import ptMessages from './pt';

export const messages = { 'en-US': enMessages, 'pt-BR': ptMessages };
